let currentMode: 'none' | 'anonymous' | 'authenticated' = 'none';

export default function useIntercomBoot() {
    const intercomAppId = useRuntimeConfig().public.intercomTrustupProApiAppId;

    const loadScriptAndBoot = (data: Record<string, any>) => {
        const bootData = {
            api_base: 'https://api-iam.intercom.io',
            app_id: intercomAppId,
            ...data,
        };

        if (window.Intercom) {
            window.Intercom('boot', bootData);
            return;
        }

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://widget.intercom.io/widget/${intercomAppId}`;
        script.onload = () => {
            window.Intercom('boot', bootData);
        };
        script.onerror = () => {
            currentMode = 'none';
        };
        document.head.appendChild(script);
    };

    const bootAnonymous = () => {
        if (!intercomAppId || currentMode !== 'none') return;
        if (localStorage.getItem('impersonateToken')) return;
        currentMode = 'anonymous';
        loadScriptAndBoot({});
    };

    const bootAuthenticated = (data: Record<string, any>) => {
        if (!intercomAppId || currentMode === 'authenticated') return;
        currentMode = 'authenticated';
        loadScriptAndBoot(data);
    };

    return { bootAnonymous, bootAuthenticated };
}
